import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { List, ListItem } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { DragHandle } from '../../components/fullTable/DragHandle';

interface IOptionListItem {
  item: any;
  id: string;
}
export const OptionListItem: FC<PropsWithChildren<IOptionListItem>> = ({ item, id, children }) => {
  const { attributes, listeners, transform, transition, setNodeRef, isDragging } = useSortable({
    id: id,
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
    backgroundColor: 'white',
  };
  return (
    <List dense style={style} ref={setNodeRef}>
      {isDragging ? (
        <ListItem key={id} style={{ cursor: 'grab', paddingLeft: 0, paddingRight: 0 }}>
          <DragHandle />
          {children}
        </ListItem>
      ) : (
        <ListItem key={id} style={{ cursor: 'grab', paddingLeft: 0, paddingRight: 0 }}>
          <DragHandle {...attributes} {...listeners} />
          {children}
        </ListItem>
      )}
    </List>
  );
};
